import { getOrigin } from '@finn/ui-utils/ssr';
import axios, { AxiosRequestConfig } from 'axios';
import { IncomingMessage } from 'http';
import get from 'lodash/get';
import values from 'lodash/values';

import { CosmicParams } from '../types/cosmicjs';

export const buildCosmicPageObjectTree = (data: any): any => {
  if (Array.isArray(data)) {
    return data
      .filter((item) => Array.isArray(item) || item?.id)
      .map((item) => {
        return buildCosmicPageObjectTree(item);
      });
  } else {
    const title = data.title || data?.slug || 'No Title';
    const id = data.id;
    const type = data.type;
    const slug = data?.slug;
    const hasChildren = data?.metadata;
    let children = null;
    if (hasChildren) {
      children = buildCosmicPageObjectTree(values(data.metadata));
    }

    return { title, id, type, slug, children };
  }
};

export const getInputPlaceholder = (pageData: any, inputId: string) =>
  get(pageData, `metadata.input_fields.${inputId}.metadata.placeholder`, '');

export const getInputTooltipText = (pageData: any, inputId: string) => {
  const item = get(pageData, 'metadata.input_hints', []).find(
    (input: object) => get(input, 'metadata.key', '') === inputId
  );

  return get(item, 'metadata.information');
};

export const getCosmicObjectWithApi = async (
  params: CosmicParams,
  req?: IncomingMessage
) => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    data: params,
    url: `${getOrigin(req)}/api/cosmic/getObject`,
  };

  try {
    const { data } = await axios(options);

    return data;
  } catch (err) {
    return null;
  }
};

export type CosmicObjectIdentifier = {
  slug: string;
  locale: string;
};
